
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ecoflow-power-kits/series/get-a-quote",
      function () {
        return require("private-next-pages/ecoflow-power-kits/series/get-a-quote/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ecoflow-power-kits/series/get-a-quote"])
      });
    }
  